//? PLUGINS //
import { Box, Card, useMediaQuery, useTheme } from "@mui/material";
import React from "react";
import * as Yup from "yup";

//? COMPONENTS //
import Content from "./step2.content";

//? STYLES //
import * as Styles from "pages/requests/stepsIndividual/step2/step2.styles";

//? EXTRA //
interface Props {
  title: string;
  onBackClick: () => void;
}

export const INITIAL_FORM_STATE_STEP2 = {
  companyName: "",
  companyResponsibleFirstName: "",
  companyResponsibleLastName: "",
  companyResponsibleEmail: "",
};

export const FORM_VALIDATION_STEP2 = (t: any) => {
  return Yup.object().shape({
    companyName: Yup.string().required("yup.required"),
    companyResponsibleFirstName: Yup.string()
      .required("yup.required")
      .nullable(),
    companyResponsibleLastName: Yup.string()
      .required("yup.required")
      .nullable(),
    companyResponsibleEmail: Yup.string()
      .email("yup.email")
      .required("yup.required")
      .nullable(),
  });
};

const Step2 = ({ title, onBackClick }: Props) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.between("xs", "lg"));

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        mt: "50px",
      }}
    >
      {isMobile ? (
        <Content title={title} onBackClick={onBackClick} />
      ) : (
        <Card sx={Styles.cardCSS(theme)}>
          <Content title={title} onBackClick={onBackClick} />
        </Card>
      )}
    </Box>
  );
};

export default Step2;
